import React from "react";
import { Redirect, useParams } from "react-router-dom";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { isPlace } from "../../../../application/domain/proc-management";

import {
  ContextProps,
  ProcManagementPlaceCreateService,
} from "../../../../application/service/service-provider/proc-management/place-create";
import { Content } from "../../../organisms/proc-management/place-form";
import { FeatureEnabledOrgOnly } from "../../../organisms/proc-management/util";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderR } from "../routes";

const ProcManagementPlaceCreate: React.FC<ContextProps> = ({
  place,
  onChange,
  onSave,
  isUpdating,
  setOrganizationId,
}) => {
  const { orgId } = useParams<{ orgId: string }>();
  const breadcrumbs = [
    { to: ServiceProviderR.Home.link({}), title: "テナント一覧" },
    {
      to: ServiceProviderR.ProcManagementProcsList.link({ orgId }),
      title: "手続きマスタ",
    },
    {
      to: ServiceProviderR.ProcManagementPlacesList.link({ orgId }),
      title: "場所マスタ",
    },
    {
      to: ServiceProviderR.ProcManagementPlaceCreate.link({ orgId }),
      title: "新規作成",
    },
  ];

  React.useEffect(() => {
    setOrganizationId(orgId);
  }, [setOrganizationId, orgId]);

  if (isPlace(place)) {
    return (
      <Redirect
        to={ServiceProviderR.ProcManagementPlaceDetail.link({
          orgId,
          placeId: place.id,
        })}
      />
    );
  }

  return (
    <FeatureEnabledOrgOnly>
      <ServiceProviderTemplate breadcrumbs={breadcrumbs}>
        <Content
          place={place}
          onChange={onChange}
          onPressSave={onSave}
          isUpdating={isUpdating}
        />
      </ServiceProviderTemplate>
    </FeatureEnabledOrgOnly>
  );
};

export const ProcManagementPlaceCreateContainer = connectPageService(
  ProcManagementPlaceCreate,
  () => new ProcManagementPlaceCreateService(),
);
